import { postREST } from '@repo/commons/utils'
import type {
	InputControllerApiRegisterInputRequest,
	InteractionResult,
	SessionControllerApiGetInitialPromptRequest,
	SessionInitParameters
} from '@semanticedge/chatbridge-noheaders-client/src'

let CHAT_SERVER = ''
export function setChatServerUrl(url?: string) {
	CHAT_SERVER = url ?? ''
}

export async function initChatBridgeSession(
	sessionInitParameters: SessionInitParameters
): Promise<string> {
	return postREST<{ sessionId: string }>(
		`${CHAT_SERVER}init-session`,
		undefined,
		sessionInitParameters
	).then((response) => response.data.sessionId)
}

export async function getInitialPrompt(
	initialPromptRequest: SessionControllerApiGetInitialPromptRequest
): Promise<InteractionResult> {
	return postREST<InteractionResult>(
		`${CHAT_SERVER}get-initial-prompt`,
		undefined,
		initialPromptRequest
	).then((response) => response.data)
}

export async function registerInput(
	registerInputRequest: InputControllerApiRegisterInputRequest
): Promise<InteractionResult> {
	return postREST<InteractionResult>(
		`${CHAT_SERVER}register-input`,
		undefined,
		registerInputRequest
	).then((response) => response.data)
}
